import { SecLoanPurposeType, SecLoansHousingLoanTargetType } from '@shared/sec-loans'
import { OptionalAndNullable } from '@shared/typeHelpers'
import { AddressInfoData } from '@shared/types'
import { convertUndefinedToNull } from '@ui-common/utils/form'

import { AddressInfoStepData, StepDataValidator } from '../../../types'
import { isFormDataValid } from '../../../wizardData'
import { createFormValidator } from './formValidator'
import { AddressInfoFormData } from './types'

export const convertToFormValues = (
  addressData: AddressInfoStepData | undefined,
): OptionalAndNullable<AddressInfoFormData> => {
  return convertUndefinedToNull({
    street: addressData?.street,
    postalCode: addressData?.postalCode,
    postOffice: addressData?.postOffice,
  })
}

export const convertToSubmitData = (formData: AddressInfoFormData): AddressInfoStepData => {
  return {
    street: formData.street,
    postalCode: formData.postalCode,
    postOffice: formData.postOffice,
  }
}

export const getAndValidateAddressInfoTypeData: StepDataValidator<AddressInfoData | undefined | null> = ({
  validationData,
  applicationMetadata,
}) => {
  const isKnownTarget =
    validationData.targetInfo?.housingLoanInfo?.targetTypeInfo?.targetType !== SecLoansHousingLoanTargetType.NotKnown
  const isConstructionPurpose = applicationMetadata?.applicationPurpose === SecLoanPurposeType.Construction

  if (!isKnownTarget || isConstructionPurpose) {
    return null
  }
  const addressInfoData = validationData.targetInfo?.addressInfoData
  const isValidData = isFormDataValid(convertToFormValues(addressInfoData), createFormValidator)
  return isValidData ? addressInfoData : undefined
}
